import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useRef, useState } from 'react';
import useDataFetch from '@scentregroup/shared/hooks/use-data-fetch';
import { makeOffsetlessTimeGetters, makeClients, doQueryAlgolia } from './algolia-helpers';
import { useLocalUser } from '../../hooks/use-local-user';
export default function useAlgolia(algoliaApiKeys, country, centre, initialQuery) {
  const {
    0: query,
    1: setQuery_
  } = useState(initialQuery || '');
  const {
    0: isError,
    1: setIsError
  } = useState(false);
  const user = useLocalUser();
  const context = _objectSpread({
    country,
    centre,
    user
  }, makeOffsetlessTimeGetters(country, centre));
  const clients = useRef(makeClients(algoliaApiKeys));
  const makeInput = q => ({
    clients: clients.current,
    context,
    query: q
  });
  const fetching = useDataFetch(doQueryAlgolia, _err => {
    // TODO When Sentry becomes available as Context, log the err
    setIsError(true);
    return {};
  }, initialQuery === undefined ? undefined : makeInput(initialQuery));
  const setQuery = query_ => {
    setIsError(false);
    fetching.setInput(makeInput(query_));
    setQuery_(query_);
  };
  const results = fetching.status === 'data' && query.length > 0 ? fetching.output : {};
  const isLoading = fetching.status === 'loading';
  const isInitialised = Boolean(clients.current);
  return {
    query,
    isLoading,
    isError,
    results,
    setQuery,
    isInitialised
  };
}